__turbopack_export_value__({
  "body-logo-18": "dropdown-module-scss-module__cqLMqG__body-logo-18",
  "body-text-12": "dropdown-module-scss-module__cqLMqG__body-text-12",
  "body-text-14": "dropdown-module-scss-module__cqLMqG__body-text-14",
  "body-text-16": "dropdown-module-scss-module__cqLMqG__body-text-16",
  "body-text-18": "dropdown-module-scss-module__cqLMqG__body-text-18",
  "body-text-20": "dropdown-module-scss-module__cqLMqG__body-text-20",
  "body-text-24": "dropdown-module-scss-module__cqLMqG__body-text-24",
  "body-text-24-2": "dropdown-module-scss-module__cqLMqG__body-text-24-2",
  "body-text-heading-2": "dropdown-module-scss-module__cqLMqG__body-text-heading-2",
  "body-text-heading-3": "dropdown-module-scss-module__cqLMqG__body-text-heading-3",
  "body-text-medium-14": "dropdown-module-scss-module__cqLMqG__body-text-medium-14",
  "body-text-medium-16": "dropdown-module-scss-module__cqLMqG__body-text-medium-16",
  "body-text-medium-18": "dropdown-module-scss-module__cqLMqG__body-text-medium-18",
  "body-text-medium2-18": "dropdown-module-scss-module__cqLMqG__body-text-medium2-18",
  "body-text2-14": "dropdown-module-scss-module__cqLMqG__body-text2-14",
  "body-text2-16": "dropdown-module-scss-module__cqLMqG__body-text2-16",
  "button-primary-text": "dropdown-module-scss-module__cqLMqG__button-primary-text",
  "button-text": "dropdown-module-scss-module__cqLMqG__button-text",
  "button2-text": "dropdown-module-scss-module__cqLMqG__button2-text",
  "card-shadow": "dropdown-module-scss-module__cqLMqG__card-shadow",
  "dropdown": "dropdown-module-scss-module__cqLMqG__dropdown",
  "dropdownMenu": "dropdown-module-scss-module__cqLMqG__dropdownMenu",
  "dropdownToggle": "dropdown-module-scss-module__cqLMqG__dropdownToggle",
  "effect-menu": "dropdown-module-scss-module__cqLMqG__effect-menu",
  "header-1": "dropdown-module-scss-module__cqLMqG__header-1",
  "main-container": "dropdown-module-scss-module__cqLMqG__main-container",
  "main-footer-container": "dropdown-module-scss-module__cqLMqG__main-footer-container",
  "main-header-container": "dropdown-module-scss-module__cqLMqG__main-header-container",
  "txt-12-bold": "dropdown-module-scss-module__cqLMqG__txt-12-bold",
  "txt-14-bold": "dropdown-module-scss-module__cqLMqG__txt-14-bold",
  "txt-14-bold-caps": "dropdown-module-scss-module__cqLMqG__txt-14-bold-caps",
  "txt-14-med": "dropdown-module-scss-module__cqLMqG__txt-14-med",
  "txt-16-bold": "dropdown-module-scss-module__cqLMqG__txt-16-bold",
  "txt-16-med": "dropdown-module-scss-module__cqLMqG__txt-16-med",
  "txt-18-bold": "dropdown-module-scss-module__cqLMqG__txt-18-bold",
  "txt-18-medium": "dropdown-module-scss-module__cqLMqG__txt-18-medium",
  "txt-18-medium-24": "dropdown-module-scss-module__cqLMqG__txt-18-medium-24",
  "txt-24-semi": "dropdown-module-scss-module__cqLMqG__txt-24-semi",
});
